import { createContext } from "../../helpers/createContext";

import { IPopupContext } from "./types";

const [PopupContext, usePopupContext] = createContext<IPopupContext>();

export { PopupContext, usePopupContext };
